var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.add_user"),
            "close-on-click-modal": false,
            visible: _vm.dialogUserVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUserVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("system.account_details")) + " "),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("tips.enter_account_details_new_user")) + " "
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form-contaniner",
              attrs: {
                model: _vm.form,
                "label-width": "200px",
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("system.username"),
                    prop: "username",
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      size: "small",
                      placeholder: "Enter username",
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "username", $$v)
                      },
                      expression: "form.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("system.login_email"),
                    prop: "email",
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      size: "small",
                      placeholder: "Enter login email",
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("system.password"),
                    prop: "password",
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "search-frame",
                    attrs: {
                      type: "password",
                      size: "small",
                      placeholder: "Enter password",
                      autocomplete: "off",
                      clearable: "",
                      "show-password": "",
                      readonly: _vm.flag,
                    },
                    on: { focus: _vm.getFocus },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogUserVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "info", disabled: _vm.listLoading },
                  on: {
                    click: function ($event) {
                      return _vm.submitAddUser("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }